<div style="width: 920px; height: 600px;" data-cy="ar-ledger-procedure-details">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-ledger-procedure-details-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-ledger-procedure-details-header">
      <div class="section-header-title" data-cy="ar-ledger-procedure-details-title">
        Ledger Item Details
      </div>
      <div style="flex: 1;" data-cy="ar-ledger-procedure-details-header-spacer"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;" data-cy="ar-ledger-procedure-details-content">
      <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="ar-ledger-procedure-details-spinner"></app-tdo-progress-spinner>
      <div *ngIf="!isLoading" style="flex: 1; overflow-y: hidden;" data-cy="ar-ledger-procedure-details-loaded-content">

        <!-- body of window-->
        <div style="display: flex; padding-right:10px" data-cy="ar-ledger-procedure-details-body">
          <div style="flex:1; padding-right:10px" data-cy="ar-ledger-procedure-details-left-col">

            <div style="display: flex" class="cell-container" data-cy="ar-ledger-procedure-details-tooth-container">
              <div style="flex-basis: 100px" data-cy="ar-ledger-procedure-details-tooth-label">Tooth/Case</div>
              <div style="flex-basis: 100px" class="info-cell" data-cy="ar-ledger-procedure-details-tooth-value">{{ ledgerItem.dataARTransactionItemList.TeethReference ? ledgerItem.dataARTransactionItemList.TeethReference : '&nbsp;' }}</div>
            </div>

            <div style="display: flex" class="cell-container" data-cy="ar-ledger-procedure-details-posted-container">
              <div style="flex-basis: 100px" data-cy="ar-ledger-procedure-details-posted-label">Posted</div>
              <div style="flex-basis: 100px" class="info-cell" data-cy="ar-ledger-procedure-details-posted-value">{{ ledgerItem.PostDate === null ? '&nbsp;' : ledgerItem.PostDate | date }}</div>
            </div>

            <div style="display: flex" class="cell-container" data-cy="ar-ledger-procedure-details-reference-container">
              <div style="flex-basis: 100px" data-cy="ar-ledger-procedure-details-reference-label">Reference</div>
              <div style="flex:1" class="info-cell" data-cy="ar-ledger-procedure-details-reference-value">{{ ledgerItem.Reference ? ledgerItem.Reference : '&nbsp;' }}</div>
            </div>
          </div>

          <div style="flex:1; padding-left:10px" data-cy="ar-ledger-procedure-details-right-col">

            <div style="display: flex" class="cell-container" data-cy="ar-ledger-procedure-details-code-container">
              <div style="flex-basis: 120px" data-cy="ar-ledger-procedure-details-code-label">Code</div>
              <div style="flex-basis: 100px" class="info-cell" data-cy="ar-ledger-procedure-details-code-value">{{ ledgerItem.dataARTransactionItemList.Code ? ledgerItem.dataARTransactionItemList.Code : '&nbsp;' }}</div>
            </div>

            <div style="display: flex" class="cell-container" data-cy="ar-ledger-procedure-details-standard-fee-container">
              <div style="flex-basis: 120px" data-cy="ar-ledger-procedure-details-standard-fee-label">Standard Fee</div>
              <div style="flex-basis: 100px; text-align: right; margin-right: 20px;" class="info-cell" data-cy="ar-ledger-procedure-details-standard-fee-value">{{ ledgerItem.dataARTransactionItemList.Price === null ? '&nbsp;' : ledgerItem.dataARTransactionItemList.Price | currency }}</div>
            </div>

            <div style="display: flex" class="cell-container" data-cy="ar-ledger-procedure-details-contracted-fee-container">
              <div style="flex-basis: 120px" data-cy="ar-ledger-procedure-details-contracted-fee-label">Contracted Fee</div>
              <div style="flex-basis: 100px; text-align: right;" class="info-cell" data-cy="ar-ledger-procedure-details-contracted-fee-value">{{ ledgerItem.dataARTransactionItemList.DoctorsPrice === null ? '&nbsp;' : ledgerItem.dataARTransactionItemList.DoctorsPrice | currency }}</div>
            </div>
          </div>
        </div>

        <div style="display: flex; flex-direction: row" data-cy="ar-ledger-procedure-details-description-container">
          <div style="flex-basis: 100px" data-cy="ar-ledger-procedure-details-description-label">Description</div>
          <div style="flex:1; height: 60px" class="info-cell" data-cy="ar-ledger-procedure-details-description-value">{{ ledgerItem.Description ? ledgerItem.Description : '&nbsp;' }}</div>
        </div>

        <div style="display: flex; padding-top:10px;" data-cy="ar-ledger-procedure-details-estimates">
          <div style="flex:1; padding-right:10px" data-cy="ar-ledger-procedure-details-patient-estimate-container">
            <!--    patient estimate-->
            <div class="pat-insur-column-header" data-cy="ar-ledger-procedure-details-patient-estimate-header">
              Original Patient Estimate: {{ ledgerItem.dataARTransactionItemList.PatientResponsibility | currency }}
            </div>
            <div style="display: flex; flex-direction: column; height: 200px; border: solid 1px #cccccc; border-top: none; border-bottom: none; overflow: auto" data-cy="ar-ledger-procedure-details-patient-adjustments">
              <div *ngFor="let item of this.adjustmentsPatient" data-cy="ar-ledger-procedure-details-patient-adjustment-item">
                <div data-cy="procedure-details-patient-results" style="display: flex; flex-direction: row;" [ngClass]="this.isVoidedDistribution(item) ? 'voided-distribution' : ''">

                  <div style="flex: 2" class="distrib-cell" data-cy="ar-ledger-procedure-details-patient-date">{{ item.Date | date }}</div>
                  <div style="flex: 1; text-align: right" class="distrib-cell" data-cy="ar-ledger-procedure-details-patient-amount">{{ item.Amount | currency }}</div>
                  <div style="flex: 2" class="distrib-cell" data-cy="ar-ledger-procedure-details-patient-source">{{ (item.PaymentSource ? item.PaymentSource : '') + ' (' + item.PaymentDistributionTypeName + ')' }}</div>
                </div>
              </div>
            </div>

            <div class="pat-insur-column-header" style="font-weight: bold" data-cy="ar-ledger-procedure-details-patient-due">
              Amount Due: {{ ledgerItem.AmountDuePatient | currency }}
            </div>
          </div>
          <div style="flex:1; padding-left:10px" data-cy="ar-ledger-procedure-details-insurance-estimate-container">
            <!--    insurance estimate-->
            <div class="pat-insur-column-header" data-cy="ar-ledger-procedure-details-insurance-estimate-header">
              Insurance Estimate: {{ ledgerItem.dataARTransactionItemList.InsuranceAmount | currency }}
            </div>
            <div style="display: flex; flex-direction: column; height: 200px; border: solid 1px #cccccc; border-top: none; border-bottom: none; overflow: auto" data-cy="ar-ledger-procedure-details-insurance-adjustments">
              <div *ngFor="let item of this.adjustmentsInsurance" data-cy="ar-ledger-procedure-details-insurance-adjustment-item">
                <div data-cy="procedure-details-insurance-results" style="display: flex; flex-direction: row" [ngClass]="this.isVoidedDistribution(item) ? 'voided-distribution' : ''">
                  <div style="flex: 2" class="distrib-cell" data-cy="ar-ledger-procedure-details-insurance-date">{{ item.Date | date }}</div>
                  <div style="flex: 1; text-align: right" class="distrib-cell" data-cy="ar-ledger-procedure-details-insurance-amount">{{ item.Amount | currency }}</div>
                  <div style="flex: 2" class="distrib-cell" data-cy="ar-ledger-procedure-details-insurance-source">{{ item.PaymentSource + ' (' + item.PaymentDistributionTypeName + ')' }}</div>
<!--                  <div style="flex: 1" class="distrib-cell">{{ item.debitCredit }}</div>-->
                </div>
              </div>
            </div>
            <div class="pat-insur-column-header" style="font-weight: bold" data-cy="ar-ledger-procedure-details-insurance-due">
              Amount Due: {{ ledgerItem.AmountDueInsurance | currency }}
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px; padding-right: 10px;" data-cy="ar-ledger-procedure-details-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="ar-ledger-procedure-details-footer-spacer"></div>
      <button data-cy="procedure-details-close-btn" (click)="close()" class="tdo-button tdo-close">Close</button>
    </div>
  </div>
</div>


